export enum PaymentTypeEnum {
    ANTICIPATED = 10,
    POSTPONED   = 20
}